import { Application, Container } from 'pixi.js';

export class PixiGlobal {
  public static app: Application | null;
  public static stage: Container | null;

  /** 保存当前引用，用于 BookCanvas 临时接管后恢复编辑器上下文 */
  private static savedApp: Application | null = null;
  private static savedStage: Container | null = null;

  constructor() {}

  public static init(app: Application) {
    // 使用类名直接访问静态变量
    this.app = app;
    this.stage = app.stage;
  }

  /**
   * 保存当前的 app / stage 引用，供 restore() 恢复。
   * 用于编辑器预览等场景：BookCanvas 在 initOthers 中接管 PixiGlobal 前，
   * 先调用 save() 保存编辑器的引用，destroy 时再调用 restore() 还原。
   */
  public static save() {
    this.savedApp = this.app;
    this.savedStage = this.stage;
  }

  /**
   * 恢复到 save() 时保存的 app / stage 引用。
   * 若之前没有保存过（如独立阅读端），则直接清理当前引用，
   * 避免持有已销毁的 Application 悬空引用。
   */
  public static restore() {
    if (this.savedApp) {
      this.app = this.savedApp;
      this.stage = this.savedStage;
      this.savedApp = null;
      this.savedStage = null;
    } else {
      this.destroy();
    }
  }

  public static getResolutionSize() {
    const width = this.app?.screen.width ?? 0;
    const height = this.app?.screen.height ?? 0;

    return { width, height };
  }

  /**
   * 获取文本元素的最佳渲染分辨率。
   *
   * Canvas 2D 文字渲染缺少次像素抗锯齿，需要对所有分辨率做
   * 固定 2x 超采样补偿清晰度。始终取渲染器分辨率 × 2。
   *
   * - 1x 屏 → 2（2x 超采样）
   * - 2x 屏 → 4（2x 超采样）
   * - 3x 屏 → 6（2x 超采样）
   */
  public static getTextResolution(): number {
    const rendererRes = this.app?.renderer?.resolution ?? 1;
    return rendererRes * 2;
  }

  public static getDisplayRatio() {
    if (!this.app) return 1;
    const { width } = this.getResolutionSize();

    // parseInt('') → NaN 当 canvas 通过 CSS 类设置宽度而非内联 style 时
    const styleWidth = parseInt(this.app.canvas.style.width);
    const cssWidth = Number.isFinite(styleWidth) ? styleWidth : this.app.canvas.clientWidth;

    return cssWidth / (width || 1);
  }

  public static destroy() {
    this.app = null;
    this.stage = null;
  }
}
